export enum Jurisdictions {
  'CA-AB' = 'Alberta',
  'US-AL' = 'Alabama',
  'US-AK' = 'Alaska',
  'US-AR' = 'Arkansas',
  'US-AS' = 'American Samoa',
  'US-AZ' = 'Arizona',
  'CA-BC' = 'British Columbia',
  'US-CA' = 'California',
  'US-CO' = 'Colorado',
  'US-CT' = 'Connecticut',
  'US-DE' = 'Delaware',
  'US-DC' = 'District Of Columbia',
  'US-FL' = 'Florida',
  'US-GA' = 'Georgia',
  'US-GU' = 'Guam',
  'US-HI' = 'Hawaii',
  'US-ID' = 'Idaho',
  'US-IL' = 'Illinois',
  'US-IN' = 'Indiana',
  'US-IA' = 'Iowa',
  'US-KS' = 'Kansas',
  'US-KY' = 'Kentucky',
  'US-LA' = 'Louisiana',
  'US-ME' = 'Maine',
  'US-MD' = 'Maryland',
  'US-MA' = 'Massachusetts',
  'CA-MB' = 'Manitoba',
  'MX-NA' = 'Mexico',
  'US-MI' = 'Michigan',
  'US-MN' = 'Minnesota',
  'US-MS' = 'Mississippi',
  'US-MO' = 'Missouri',
  'US-MP' = 'Northern Mariana Islands',
  'US-MT' = 'Montana',
  'CA-NB' = 'New Brunswick',
  'US-NC' = 'North Carolina',
  'US-NE' = 'Nebraska',
  'US-NH' = 'New Hampshire',
  'US-NJ' = 'New Jersey',
  'CA-NL' = 'Newfoundland and Labrador',
  'US-NM' = 'New Mexico',
  'CA-NT' = 'Northwest Territories',
  'CA-NU' = 'Nunavut',
  'CA-NS' = 'Nova Scotia',
  'US-NV' = 'Nevada',
  'US-NY' = 'New York',
  'US-ND' = 'North Dakota',
  'US-OH' = 'Ohio',
  'US-OK' = 'Oklahoma',
  'CA-ON' = 'Ontario',
  'US-OR' = 'Oregon',
  'US-PA' = 'Pennsylvania',
  'CA-PE' = 'Prince Edward Island',
  'US-PR' = 'Puerto Rico',
  'CA-QC' = 'Quebec',
  'US-RI' = 'Rhode Island',
  'US-SC' = 'South Carolina',
  'US-SD' = 'South Dakota',
  'CA-SK' = 'Saskatchewan',
  'US-TN' = 'Tennessee',
  'US-TX' = 'Texas',
  'US-UT' = 'Utah',
  'US-UM' = 'United States Minor Outlying Islands',
  'US-VI' = 'Virgin Islands',
  'US-VA' = 'Virginia',
  'US-VT' = 'Vermont',
  'US-WA' = 'Washington',
  'US-WI' = 'Wisconsin',
  'US-WV' = 'West Virginia',
  'US-WY' = 'Wyoming',
  'CA-YT' = 'Yukon'
}


//                                Add sorting to the Jurisdictions enum.

// Create a string array to store the keys of the Jurisdictions
const keys = Object.keys(Jurisdictions);

// Sort the keys based on the values of each one.
keys.sort((a,b) => Jurisdictions[a as keyof typeof Jurisdictions].localeCompare(Jurisdictions[b as keyof Jurisdictions]));

// Create a new object with the sorted keys and their original values.
const sortedJurisdictions = {};
keys.forEach((key) => {
  sortedJurisdictions[key] = Jurisdictions[key as keyof typeof Jurisdictions];
})

// Cast the sorted object to return it
export const JurisdictionsAplOrder = sortedJurisdictions as typeof Jurisdictions;

// These are the jurisdictions that support IFTA reporting
// TODO Create extra fields on enum instead of new enum object
export enum IFTAJurisdictions {
  'CA-AB' = 'Alberta',
  'US-AL' = 'Alabama',
  'US-AR' = 'Arkansas',
  'US-AZ' = 'Arizona',
  'CA-BC' = 'British Columbia',
  'US-CA' = 'California',
  'US-CO' = 'Colorado',
  'US-CT' = 'Connecticut',
  'US-DE' = 'Delaware',
  'US-FL' = 'Florida',
  'US-GA' = 'Georgia',
  'US-IA' = 'Iowa',
  'US-ID' = 'Idaho',
  'US-IL' = 'Illinois',
  'US-IN' = 'Indiana',
  'US-KS' = 'Kansas',
  'US-KY' = 'Kentucky',
  'US-MA' = 'Massachusetts',
  'CA-MB' = 'Manitoba',
  'US-MI' = 'Michigan',
  'US-MN' = 'Minnesota',
  'US-MO' = 'Missouri',
  'US-MS' = 'Mississippi',
  'US-MT' = 'Montana',
  'CA-NB' = 'New Brunswick',
  'US-NC' = 'North Carolina',
  'US-NE' = 'Nebraska',
  'US-NH' = 'New Hampshire',
  'US-NJ' = 'New Jersey',
  'CA-NL' = 'Newfoundland and Labrador',
  'US-NM' = 'New Mexico',
  'CA-NS' = 'Nova Scotia',
  'US-NV' = 'Nevada',
  'US-NY' = 'New York',
  'US-OH' = 'Ohio',
  'US-OK' = 'Oklahoma',
  'CA-ON' = 'Ontario',
  'US-OR' = 'Oregon',
  'US-PA' = 'Pennsylvania',
  'CA-PE' = 'Prince Edward Island',
  'CA-QC' = 'Quebec',
  'US-SC' = 'South Carolina',
  'US-SD' = 'South Dakota',
  'CA-SK' = 'Saskatchewan',
  'US-TN' = 'Tennessee',
  'US-TX' = 'Texas',
  'US-UT' = 'Utah',
  'US-VA' = 'Virginia',
  'US-VT' = 'Vermont',
  'US-WA' = 'Washington',
  'US-WI' = 'Wisconsin',
  'US-WV' = 'West Virginia',
  'US-WY' = 'Wyoming'
}
